"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _toArray = _interopRequireDefault(require("lodash/toArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = require("../Input");

var _Types = require("./Types");

var _scrubDataByType = require("./utils/scrubDataByType");

var _isValidByType = require("./utils/isValidByType");

var _excluded = ["isRequired", "onChange", "reference", "supplementalValidator", "type"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TextBasedInput(props) {
  var isRequired = props.isRequired,
      onChange = props.onChange,
      reference = props.reference,
      supplementalValidator = props.supplementalValidator,
      type = props.type,
      remainingProps = _objectWithoutProperties(props, _excluded);

  function onInputChange(event) {
    onChange((0, _scrubDataByType.scrubDataByType)(type, event.target.value));
  }

  function isValid() {
    return (0, _isValidByType.isValidByType)(type, remainingProps.value, isRequired) && supplementalValidator();
  }

  return /*#__PURE__*/_react["default"].createElement(_Input.Input, _extends({}, remainingProps, {
    isValid: isValid(),
    onChange: function onChange(event) {
      return onInputChange(event);
    },
    reference: reference
  }));
}

TextBasedInput.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  type: _propTypes["default"].oneOf((0, _toArray["default"])(_Types.Types)).isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  isRequired: _propTypes["default"].bool,
  reference: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].instanceOf(Object)]),
  supplementalValidator: _propTypes["default"].func
};
TextBasedInput.defaultProps = {
  isRequired: false,
  supplementalValidator: function supplementalValidator() {
    return true;
  }
};
var _default = TextBasedInput;
exports["default"] = _default;